goog.provide("shadow.js.shim.module$src$svg$files_folders$file_new_svg$default");
shadow.js.shim.module$src$svg$files_folders$file_new_svg$default = shadow.js.shim.module$src$svg$files_folders$file_new_svg.default;
